"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { MoveLeft } from "lucide-react";
import { Button } from "./ui/button";
import ProductCard from "./ProductCard";

// Lazy load Swiper to reduce initial bundle size
let Swiper = null;
let SwiperSlide = null;


export default function ProductSlider({ data, href = "", priorityFirst = false }) {
  const [swiperLoaded, setSwiperLoaded] = useState(false);
  const productsArray = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);

  useEffect(() => {
    // Load Swiper only when component mounts
    Promise.all([
      import("swiper/react"),
      import("swiper/css"),
      import("swiper/css/pagination")
    ]).then(([swiperModule]) => {
      Swiper = swiperModule.Swiper;
      SwiperSlide = swiperModule.SwiperSlide;
      setSwiperLoaded(true);
    }).catch(err => {
      console.error("Failed to load Swiper:", err);
    });
  }, []);

  // Show loading state or fallback
  if (!swiperLoaded || !Swiper || !SwiperSlide) {
    return (
      <div className="w-full px-4">
        <div className="flex gap-4 lg:gap-6 overflow-x-auto my-10 lg:my-14 pb-4 scrollbar-hide">
          {productsArray.slice(0, 4).map((product, index) => (
            <div key={product.id} className="flex-shrink-0">
              <ProductCard product={product} priority={priorityFirst && index === 0} />
            </div>
          ))}
        </div>
        {href && (
          <div className="flex justify-center mt-6">
            <Link href={href}>
              <Button size="xl" className="mx-auto" variant="berryBorder">
                مشاهده همه موارد
                <MoveLeft className="text-white" />
              </Button>
            </Link>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="w-full overflow-hidden px-4">
      <Swiper
        slidesPerView="auto"
        spaceBetween={16}
        watchSlidesProgress={true}
        grabCursor={true}
        className="mySwiper my-10 overflow-hidden lg:my-14 lg:overflow-visible"
        breakpoints={{ 1024: { spaceBetween: 24 } }}>
        {productsArray.map((product, index) => (
          <SwiperSlide key={product.id} className="w-auto!">
            <ProductCard product={product} priority={priorityFirst && index === 0} />
          </SwiperSlide>
        ))}
      </Swiper>
      {href && (
        <div className="flex justify-center mt-6">
          <Link href={href}>
            <Button size="xl" className="mx-auto" variant="berryBorder">
              مشاهده همه موارد
              <MoveLeft className="text-white" />
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
